import { CustomIconProps } from 'assets/Icons/LibraryIcon';
import React from 'react';

const VideoIndex: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? 40}
      height={height ?? 40}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M6.66732 36.6693C5.75065 36.6693 4.96593 36.3429 4.31315 35.6901C3.66037 35.0373 3.33398 34.2526 3.33398 33.3359V16.6693C3.33398 15.7526 3.66037 14.9679 4.31315 14.3151C4.96593 13.6623 5.75065 13.3359 6.66732 13.3359H33.334C34.2506 13.3359 35.0354 13.6623 35.6881 14.3151C36.3409 14.9679 36.6673 15.7526 36.6673 16.6693V33.3359C36.6673 34.2526 36.3409 35.0373 35.6881 35.6901C35.0354 36.3429 34.2506 36.6693 33.334 36.6693H6.66732ZM6.66732 33.3359H33.334V16.6693H6.66732V33.3359ZM16.6673 31.6693L26.6673 25.0026L16.6673 18.3359V31.6693ZM6.66732 11.6693V8.33594H33.334V11.6693H6.66732ZM11.6673 6.66927V3.33594H28.334V6.66927H11.6673Z'
        fill={fill ?? 'white'}
      />
    </svg>
  );
};

export default VideoIndex;
